import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import './AnmeldenPage.css';
import PasswortRegeln from '../components/passwort/PasswortRegeln';
import { passwortFehler } from '../lib/passwortRegel';

// 18.10.2026: im Design der Anmeldeseite (rot, hell/dunkel).

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    async function checkToken() {
      if (!token) { setChecking(false); return; }
      try {
        const r = await fetch(`/api/auth/reset-password/check?token=${token}`);
        const d = await r.json();
        setTokenValid(d.valid);
      } catch { setTokenValid(false); }
      finally { setChecking(false); }
    }
    checkToken();
  }, [token]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (newPassword !== confirm) { setError('Passwörter stimmen nicht überein'); return; }
    // Eine Passwortregel für alle Konten (25.10.2026, lib/passwortRegel.js)
    const pwFehler = passwortFehler(newPassword);
    if (pwFehler) { setError(pwFehler); return; }
    setLoading(true);
    try {
      const r = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword })
      });
      const d = await r.json().catch(() => ({}));
      if (r.ok && d.success) setDone(true);
      else setError(d.error || 'Fehler beim Zurücksetzen');
    } catch { setError('Verbindungsfehler'); }
    finally { setLoading(false); }
  }

  return (
    <div className="anm-seite">
      <div className="anm-karte">
        <div className="anm-kopf">
          <Link to="/" className="anm-logo-link" aria-label="Zur Startseite">
            <img src="/logo.webp" alt="TDA" className="anm-logo" width="64" height="64" />
          </Link>
          <span className="anm-marke">TDA Tournament Center</span>
          <h1>Neues Passwort</h1>
        </div>
        {checking ? (
          <p className="anm-hinweis">Link wird geprüft…</p>
        ) : done ? (
          <div className="anm-form">
            <div className="anm-erfolg" role="status">Passwort gespeichert. Bitte mit dem neuen Passwort anmelden.</div>
            <button className="anm-knopf" onClick={() => navigate('/anmelden')}>Zur Anmeldung</button>
          </div>
        ) : !tokenValid ? (
          <div className="anm-form">
            <div className="anm-fehler" role="alert">Der Link ist ungültig oder abgelaufen.</div>
            <Link to="/forgot-password" className="anm-vergessen">Neuen Link anfordern</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="anm-form">
            <label className="anm-feld">Neues Passwort
              <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required minLength={8}
                autoComplete="new-password" autoFocus disabled={loading} aria-describedby="pw-regeln" />
              <PasswortRegeln passwort={newPassword} id="pw-regeln" />
            </label>
            <label className="anm-feld">Passwort wiederholen
              <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required
                autoComplete="new-password" disabled={loading} />
            </label>
            {error && <div className="anm-fehler" role="alert">{error}</div>}
            <button type="submit" className="anm-knopf" disabled={loading}>{loading ? 'Wird gespeichert…' : 'Passwort speichern'}</button>
          </form>
        )}
      </div>
      <Link to="/anmelden" className="anm-zurueck">← Zur Anmeldung</Link>
    </div>
  );
}
